const Subscribe = () => {
  return (
    <div className="">
      <button
        className="md:w-full italic lg:p-5 text-sm p-4 px-16 lg:px-0  rounded-full 
     bg-customRed  tracking-wider  text-white font-semibold xl:text-xl 3xl:text-2xl
    hover:bg-white hover:text-customRed
    hover:scale-[0.95] transition-all duration-500"
      >
        <h2>ĐẶT NGAY</h2>
      </button>
    </div>
  );
};

export default Subscribe;
